import React from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import styles from '../ChatWidget.module.scss';

export default function NewChatButton() {
  const { resetConversation, currentConversationId } = useChatWidgetContext();

  return (
    <button
      type="button"
      className={styles.headerButton}
      onClick={resetConversation}
      disabled={currentConversationId === null}
      aria-label="New chat"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </button>
  );
}
